module.exports = __webpack_public_path__ + "static/media/btg_07.a9d2b42f.png";